import * as types from './types'
import http from '@/Plugins/api'

export default {
  setPager({ commit }, data) {
    commit(types.SET_PAGER, data)
  },
  resetProgram({ commit }, data) {
    commit(types.RESET_MEASUREMENT, data)
  },
  setChecked({ commit }, data) {
    commit(types.SET_CHECKED, data)
  },
  resetPhotos({ commit }) {
    commit(types.RESET_PHOTOS)
  },
  setPhoto({ commit }, data) {
    commit(types.SET_PHOTO, data)
  },
  async getMeasurementProfile({ commit }, data) {
    const r = await http.get(`v2/bodycomp/liveprofilebodycomp`, {
      params: data,
    })
    commit(types.SET_MEASUREMENT, r.data.data)
    return r.data.data
  },
  async getMeasurements({ commit }, data) {
    const r = await http.get(`v2/measurements`, {
      params: data,
    })
    commit(types.SET_MEASUREMENTS, r.data.data)
    return r.data.data
  },
  async getPhotos({ commit }, data) {
    const r = await http.get(`v2/photos`, {
      params: data,
    })
    commit(types.SET_PHOTOS, r.data.data)
    return r.data.data
  },
  async savePhotos({ commit }, data) {
    const r = await http.post(`v2/photos`, data)
    commit(types.UPDATE_PHOTOS, data)
    return r.data.data
  },
  async getVO2assessments({ commit }, data) {
    const r = await http.get(`v2/userassessment/vo2measurements`, {
      params: data,
    })
    commit(types.SET_VO2_ASSESSMENTS, r.data.data)
    return r.data.data
  },
  async getVO2assessment({ commit }, id) {
    const r = await http.get(`v2/userassessment/vo2measurement${id}`)
    commit(types.SET_VO2_ASSESSMENT, r.data.data)
    return r.data.data
  },
  async saveVO2assessment({ commit }, data) {
    const r = await http.post(`v2/userassessment/vo2measurement`, data)
    return r.data
  },
  async saveMeasurement({ commit }, data) {
    const r = await http.post(`v2/measurements`, data)
    return r.data
  },
}
